export interface IRequest<A extends any[] = any[]> {
  func: (...args: A) => Promise<any>;
  args?: A;
}

export interface IRequestQueue {
  addRequest: ({ func, args }: IRequest) => void;
}

export class RequestQueue implements IRequestQueue {
  private readonly queue: IRequest[] = [];

  private requestInProgress?: IRequest;

  public addRequest({ func, args }: IRequest): void {
    this.queue.push({ func, args });

    this.executeRequest();
  }

  private async executeRequest(): Promise<any> {
    if (this.queue.length && !this.requestInProgress) {
      this.requestInProgress = this.queue.shift();
      const request = this.requestInProgress;

      if (!request) {
        return;
      }

      const { func, args } = request;

      await func(...(args || []));
      this.requestInProgress = undefined;
      this.executeRequest();
    }
  }
}

export const formPatchQueue = new RequestQueue();
